import type { AdminEraseState } from '../sync/useAdminAreaErase';

/**
 * Admin area-erase selection rectangle + active-mode status banner.
 * Uses red tokens (admin accent) instead of orange — R4-P1-1 twin regression fix.
 */
export function AdminEraseOverlay({
  state,
  active,
}: {
  state: AdminEraseState;
  active: boolean;
}) {
  const isSelecting = state.kind === 'selecting' && state.endScreen;

  return (
    <>
      {isSelecting && (
        <div
          className="absolute pointer-events-none rounded-sm"
          style={{
            left: Math.min(state.startScreen[0], state.endScreen![0]),
            top: Math.min(state.startScreen[1], state.endScreen![1]),
            width: Math.abs(state.endScreen![0] - state.startScreen[0]),
            height: Math.abs(state.endScreen![1] - state.startScreen[1]),
            border: '2px dashed #fca5a5',
            background: 'rgba(252,165,165,0.18)',
            boxShadow: '0 0 0 2px rgba(255,255,255,0.3), 0 0 0 1px rgba(252,165,165,0.4) inset',
          }}
        />
      )}
      {active && (
        <div
          role="status"
          className="bb-fade-in absolute top-20 left-1/2 -translate-x-1/2 flex items-center gap-2 px-3.5 py-2 rounded-xl text-sm font-medium backdrop-blur-xl bg-red-600/90 text-white shadow-elev2"
        >
          <span className="w-2 h-2 rounded-full bg-white/90 animate-pulse" />
          区域橡皮擦 · 框选区域执行擦除
          <kbd className="ml-1 px-1.5 py-0.5 rounded-md text-[10px] font-semibold bg-white/15 border border-white/20">
            ESC
          </kbd>
          <span className="text-white/85">退出</span>
        </div>
      )}
    </>
  );
}
